const forbiddenExtensions = ['exe', 'sql', 'bat', 'bash', 'bin']
const maximumFileSize = 30 * 1000 * 1000

export const slugBetaFilePath = (value: string) => {
    let path = String(value || '').trim().toLowerCase()
    const accented = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
    const normalized = 'aaaaeeeeiiiioooouuuunc------'

    for (let index = 0; index < accented.length; index += 1) {
        path = path.replace(
            new RegExp(accented.charAt(index), 'g'),
            normalized.charAt(index),
        )
    }

    return path
        .replace(/\(/g, '')
        .replace(/\)/g, '')
        .replace(/[^a-z0-9 -|.]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
}

export const validateBetaFile = (file: File) => {
    const extension = file.name.toLowerCase().split('.').pop() || ''

    if (forbiddenExtensions.includes(extension)) {
        return `Arquivo do tipo .${extension} não suportado.`
    }

    if (file.size > maximumFileSize) {
        return 'Não é possível enviar um arquivo maior do que 30MB.'
    }

    return ''
}

export const betaFileExtension = (fileName: string) => (
    fileName.toLowerCase().split('.').pop() || ''
)
